import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from "vue3-i18n";

const lang_fr = require("../lang/fr.json");
const lang_en = require("../lang/en.json");

const messages = {
  en: lang_en,
  fr: lang_fr
};
const i18n = createI18n({
  locale: "en",
  messages: messages,
});

let app = createApp(App).use(router);
app.use(i18n);
app.config.globalProperties.langagesAvailable = [{ id: 1, name: "English", iso: "en" }];

// Ajout du script HubSpot
const hsScript = document.createElement('script');
hsScript.type = 'text/javascript';
hsScript.async = true;
hsScript.defer = true;
hsScript.id = 'hs-script-loader';
hsScript.src = '//js-eu1.hs-scripts.com/143329282.js';
document.head.appendChild(hsScript);

app.mount('#app');